// Include scss
import "../scss/index.scss";

// Images
import "./images.js";

/* 
    Libs 
*/
import HystModal from './hystmodal.js';
import "mouse-follower/src/scss/index.scss";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LazyLoad from "vanilla-lazyload";
import IMask from 'imask';

import 'vanilla-calendar-pro/styles/index.css';

import Swiper, { Autoplay } from 'swiper';
import { Pagination, Navigation, EffectFade, Lazy } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';


import { scrollTo, scrollIntoView } from 'scroll-js';

import METRIKA from "./metrika.js";

import mobileMenu from './menu.js';

import Calculator from './calculator.js';

import SenderForm from './sende.js';

import {isVideo} from './functions.js';

/*
    APP sittings
*/
gsap.registerPlugin(ScrollTrigger);

// Lazyload
document.addEventListener('DOMContentLoaded', () => {


    console.warn('Created by Georgiy Antipov a@topm.ru ');

    var myLazyLoad = new LazyLoad();

    // dvh
    const appHeight = () => document.documentElement.style.setProperty('--dynamic-height', `${window.innerHeight}px`)
    window.addEventListener('resize', appHeight)
    appHeight();

    setInterval(appHeight, 1000);


    let mySwiper = undefined;

    function initSwiper() {
        const screenWidth = window.innerWidth;
        const breakpoint = 920; // The width in pixels to destroy/initialize at

        if (screenWidth < breakpoint && mySwiper === undefined) {
            // Initialize Swiper for small screens
            mySwiper = new Swiper(".js-swiper-gallery", {
                modules: [Autoplay],
                slidesPerView: 1,
                autoplay: true,
                loop: false,
                autoHeight: true,

            });
        } else if (screenWidth > breakpoint) {
            // Destroy Swiper for large screens


            for (let elem of document.querySelectorAll(".js-swiper-gallery .swiper-slide")) {
                elem.classList.remove("swiper-slide")
            }

            for (let elem of document.querySelectorAll(".js-swiper-gallery .swiper-wrapper")) {
                elem.classList.remove("swiper-wrapper")
            }

            for (let elem of document.querySelectorAll(".js-swiper-gallery")) {
                elem.classList.remove("swiper-wrapper")
            }

            if (mySwiper !== undefined) {
                mySwiper.destroy(true, true); // deleteInstance=true, cleanStyles=true
                mySwiper = undefined; // Reset instance variable
            }
        }
    }

    // Initialize on page load
    initSwiper();

    // Re-initialize/destroy on window resize
    window.addEventListener('resize', initSwiper);

    for (let phone of document.querySelectorAll('input[name=phone]')) {
        IMask(
            phone,
            {
                mask: '+{7}(000)000-00-00'
            }
        )
    }

    const Metrika = new METRIKA();


    const Modals = new HystModal({
        linkAttributeName: "data-hystmodal",
        afterClose: function(e) {
            for(let video of e.openedWindow.querySelectorAll('video')) {
                video.pause();
            }
        }
    });


    // Примеры еды с ценами
    for (let examplesBtn of document.querySelectorAll('[data-view]')) {
        examplesBtn.addEventListener('click', () => {
         
            const exampleBlock = examplesBtn.closest('.st-example__item');            
            const dishes = exampleBlock.dataset.dishes ? exampleBlock.dataset.dishes : "";
            const guests = exampleBlock.dataset.guests ? exampleBlock.dataset.guests : "";
            const price = exampleBlock.dataset.price ? exampleBlock.dataset.price : "";

            const modal = document.querySelector("#viewModal");
            const inputDishes = modal.querySelector('[name="dishes"]');
            const inputGuests = modal.querySelector('[name="guests"]');
            const inputPrice = modal.querySelector('[name="price"]');

            inputDishes.value = dishes;
            inputGuests.value = guests;
            inputPrice.value = price;


            Modals.open("#viewModal");
        })
    }

    // СЕТ
    const formModalSet = document.querySelector("#formModalSet");
    const setModalNameInput = formModalSet.querySelector("[name='setname']");
    const setModalNameResult = formModalSet.querySelector(".js-value-name");


    for(let btn of document.querySelectorAll('.js-setOrder')) {
        btn.addEventListener("click", () => {

            const itemBlock = btn.closest('.st-sets__item');
            const name = itemBlock.querySelector('.js-name')

            setModalNameInput.value = name.innerHTML;
            setModalNameResult.innerHTML = name.innerHTML;

            Modals.open("#formModalSet");
        });
    }


    // Твой укникальный сет 
    document.querySelector('.js-uqSetOrder').addEventListener("click", () => {
        Modals.open("#formModalUqSet");
    });


    // Лофт
    const loftModalBlock = document.querySelector("#formModalLoft");
    const loftModalNameInput = loftModalBlock.querySelector("[name='name']");
    const loftModalAddressInput = loftModalBlock.querySelector("[name='address']");

    const loftModalNameResult = loftModalBlock.querySelector(".js-value-name");
    const loftModalAddressResult = loftModalBlock.querySelector(".js-value-address");
    
    for(let loftBtn of document.querySelectorAll('.js-loftOrder')) {
        loftBtn.addEventListener("click", () => {

            const loftBlock = loftBtn.closest('.st-places__item');
            const address = loftBlock.querySelector('.js-address')
            const name = loftBlock.querySelector('.js-name')

            loftModalNameInput.value = name.innerHTML;
            loftModalAddressInput.value = address.innerHTML;

            loftModalNameResult.innerHTML = name.innerHTML;
            loftModalAddressResult.innerHTML = address.innerHTML;

            Modals.open("#formModalLoft");
        });
    }


    // Шоу
    for(let orgBtn of document.querySelectorAll('.js-org')) {
        orgBtn.addEventListener("click", () => {
            const id = orgBtn.dataset.modal;

            Modals.open("#viewShowModal_"+id);
        });
    }


    // Галерея
    for (let examplesBtn of document.querySelectorAll('[data-view-gallery]')) {
        examplesBtn.addEventListener('click', () => {

            const url = examplesBtn.dataset.viewGallery;

            const modal = document.querySelector('#viewGalleryModal');

            const img   = modal.querySelector(".js-img");  
            const video = modal.querySelector(".js-video");

            if(isVideo(url)) {
                video.pause();
                video.src = url;
                video.play();
                img.style.display = "none"
                video.style.display = "block"
            } else {
                video.style.display = "none"
                img.style.display = "block"
                img.src = url;
            }

            Modals.open("#viewGalleryModal");
        })
    }

    // Меню
    const mm = new mobileMenu();

    // Преход по ссылке
    for(let link of document.querySelectorAll('[data-link]')) {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if(mm.isOpen()) {
                mm.close();
            }

            const href = link.getAttribute('href');
            const matches = href.match(/^.+(\#.+)$/);
            if(!matches[1]) {
                window.location.href = href;
                return;
            }
            const object = document.querySelector(matches[1]);

            if(!object) {
                window.location.href = href;
                return;
            }

            let headerHeight = document.querySelector(".st-header").clientHeight;

            const elementTop = object.offsetTop + window.screenTop - headerHeight*1.5 + window.outerHeight - window.innerHeight ;

            console.log(elementTop)

            scrollTo( document.body, {top: elementTop,  behavior: "smooth", duration: 2, easing: 'ease-in-out' }).then(
                function () {
                    // done scrolling document's body to show myElement
                }
            );
        });
    }

    // Калькулятор
    const calculatorInstance = new Calculator();
    calculatorInstance.setModal(Modals);


    // Отправка форм
    const SenderFormInstance = new SenderForm();


    // 

});
